import type { FC } from 'react'

import H3 from '@/components/H3'

type Props = {
  monthlyRentalShare: number
  affordabilityRatio: number
  tenancyLength: number
  affordabilityThreshold: number
}

const monthlyAffordabilityAmount = (
  monthlyRentalShare: number,
  affordabilityRatio: number,
  affordabilityThreshold: number,
): number => (monthlyRentalShare - affordabilityThreshold) * affordabilityRatio

const annualAffordabilityAmount = (
  monthlyRentalShare: number,
  affordabilityRatio: number,
  affordabilityThreshold: number,
): number =>
  monthlyAffordabilityAmount(
    monthlyRentalShare,
    affordabilityRatio,
    affordabilityThreshold,
  ) * 12

const AffordabilityStatement: FC<Props> = ({
  monthlyRentalShare,
  affordabilityRatio,
  tenancyLength,
  affordabilityThreshold,
}) => (
  <div>
    <H3>Affordability Requirements</H3>
    <p>
      To be eligible for this tenancy, the applicant must earn a minimum of{' '}
      <strong>
        £
        {annualAffordabilityAmount(
          monthlyRentalShare,
          affordabilityRatio,
          affordabilityThreshold,
        )}
      </strong>{' '}
      per annum.
    </p>
    {
      // eslint-disable-next-line eqeqeq
      tenancyLength != 12 && (
        <p>
          Over the duration of the {tenancyLength} month tenancy, that's total of{' '}
          <strong>
            £
            {monthlyAffordabilityAmount(
              monthlyRentalShare,
              affordabilityRatio,
              affordabilityThreshold,
            ) * tenancyLength}
          </strong>
          .
        </p>
      )
    }
    <p>
      {affordabilityThreshold > 0 ? (
        <i>
          (£{monthlyRentalShare} per month - £{affordabilityThreshold} affordability
          threshold) x {tenancyLength} months x affordability ratio of{' '}
          {affordabilityRatio}.
        </i>
      ) : (
        <i>
          £{monthlyRentalShare} per month x {tenancyLength} months x affordability ratio
          of {affordabilityRatio}.
        </i>
      )}
    </p>
  </div>
)

export default AffordabilityStatement
